import type { FC } from 'react';
import { HTMLAttributes } from 'react';
import c from 'classnames';
import s from './LargeButtonsWrapper.scss';

interface Props extends HTMLAttributes<HTMLDivElement> {}

const LargeButtonsWrapper: FC<Props> = ({ className, ...rest }) => (
  <div className={c(s['root'], className)} {...rest} />
);
LargeButtonsWrapper.displayName = 'LargeButtonsWrapper';

export default LargeButtonsWrapper;
